import url from "../axios/apiUrl";
import { postRequest } from "../api/index";
export default {
    //0：不跳转 1：网页 2：详情 3：列表 4：文章 5：活动页面
    toActive: function (v, that) {
        sessionStorage.removeItem('input')
        sessionStorage.removeItem('watchInput')
        sessionStorage.removeItem('id')
        sessionStorage.removeItem('page')
        sessionStorage.removeItem('isSpecial')
        sessionStorage.removeItem('resultLeval')
        if (localStorage.getItem('isLogin') == 1) {
            let token = window.localStorage.getItem('token')
            if (v.targetType != 0) {
                if (v.targetType == 3) {
                    sessionStorage.setItem('params',v.params)
                    // sessionStorage.setItem('params',JSON.stringify(v.params))
                    if (v.newTab == 0) {
                        let dataRouter = that.$router.resolve({ path: '/goodsList' })
                        window.open(dataRouter.href, '_self')
                    } else {
                        // let dataRouter = that.$router.resolve({ path: '/goodsList' })
                        // window.open(dataRouter.href, '_blank')
                        window.open(this.link + "/#/"+"goodsList", "_blank")
                        // window.open('http://192.168.1.184/#/goodsList', '_blank')
                    }
                } else if (v.targetType == 2) {
                    let isJT = 0;
                    let isSpecial = 0;
                    if (v.goodsLabel.length != 0) {
                        for (let i = 0; i < v.goodsLabel.length; i++) {
                            if (v.goodsLabel[i] == '5' || v.goodsLabel[i] == '阶梯') {
                                isJT = 1;
                            }
                            if (v.goodsLabel[i] == '1' || v.goodsLabel[i] == '特卖') {
                                isSpecial = 1;
                            }
                        }
                        postRequest(url.getGoodsById, {
                            goodsId: v.id,
                            specialSale: isSpecial,
                            clientType: 1,
                            tieredPrice: isJT
                        }).then(res => {
                            if (res.data.code == '000000') {
                                if (isJT == 1) {
                                    let dataRouter = that.$router.resolve({ path: '/ladderDetails', query: { id: v.id } })
                                    window.open(dataRouter.href, '_blank')
                                } else {
                                    let dataRouter = that.$router.resolve({ path: '/goodsDetails', query: { id: v.id } })
                                    window.open(dataRouter.href, '_blank')
                                }
                            } else if (res.data.message == "系统异常") {
                                that.$message({
                                    message: "网络异常，请稍后再试",
                                    offset: 400,
                                    duration: 2000,
                                    type: "error",
                                    showClose: true
                                });
                            } else if (res.data.code != '000000') {
                                that.$message({
                                    message: res.data.message,
                                    offset: 400,
                                    duration: 4000,
                                    type: "error",
                                    showClose: true
                                });
                            }
                        })
                    } else {
                        postRequest(url.getGoodsById, {
                            goodsId: v.id,
                            specialSale: isSpecial,
                            clientType: 1,
                            tieredPrice: isJT
                        }).then(res => {
                            if (res.data.code == '000000') {
                                let dataRouter = that.$router.resolve({ path: '/goodsDetails', query: { id: v.id } })
                                window.open(dataRouter.href, '_blank')
                            } else if (res.data.message == "系统异常") {
                                that.$message({
                                    message: "网络异常，请稍后再试",
                                    offset: 400,
                                    duration: 2000,
                                    type: "error",
                                    showClose: true
                                });
                            } else if (res.data.code != '000000') {
                                that.$message({
                                    message: res.data.message,
                                    offset: 400,
                                    duration: 4000,
                                    type: "error",
                                    showClose: true
                                });
                            }
                        })
                    }
                } else {
                    if (v.newTab == 0) {
                        if (v.url && v.url != '#') {
                            location.href = v.url
                        }
                    } else {
                        if (v.url && v.url != '#') {
                            window.localStorage.setItem('token', token)
                            window.open(v.url, '_blank')
                        }
                    }
                }
            }
        } else {
            let dataRouter = that.$router.resolve({ path: '/login' })
            window.open(dataRouter.href, '_self')
        }
    }
}


// WEBPACK FOOTER //
// ./src/config/toActive.js